export default __webpack_public_path__ + "static/media/artist2.e3aa9690.jpg";